module.exports = __webpack_public_path__ + "img/idcard3.58fc121f.png";